export const NON_BLOCKING_ERROR_STATUSES: readonly number[] = [408, 504];
